export const ru = {
  selectCity: 'Выбрать город',
  selectCountry: 'Выбрать страну',
  allCities: 'Все города',
  allCountries: 'Все страны',
  articleOnCity: 'Статьи по городам {text}',
  articleOnCountry: 'Статьи по странам {text}',
  articleOnRegion: 'Статьи по региону {text}',
};
